import { ICustomizerState } from "./customizer/customizerReducer";
import { IMessagesState } from "./messages/messages.types";
import { initialMessagesState } from "./messages/messagesState";
import { IStudentState } from "./student/student.types";
// import { IAutomobilePolicyRiskLocationState, defaultAutomobilePolicyRiskLocationState } from "./automobilePolicyRiskLocation/automobilePolicyRiskLocation.types";
import { defaultCommonState, ICommonState } from "./common/common.types";

import { IUsersState } from "./UserProfileList/userProfile.types";
import { initialUserProfileState } from "./UserProfileList/userprofileState";

import {
  IAcitivtyState,
  initialAcitvityState,
} from "./activity/activity.types";
import { ILeadsState, initialLeadState } from "./leads/leads.types";
import { defaultOpportunityState } from "./opportunites/deafaultState";
import { IOpportunityState } from "./opportunites/opportunites.types";
import {
  initialSecurityState,
  ISecurityState,
} from "./security/security.types";
import { defaultStudentState } from "./student/studentState";
import {
  initialTemplateState,
  ITemplateState,
} from "./templates/templates.types";
import { IFeeStructureState } from "./feeStructure/feeStructure.types";
import { defaultFeeStructureState } from "./feeStructure/defaultState";
import { IOrganizationState } from "./organization/type";
import { defaultOrganizationState } from "./organization/default";
import { IReportsState } from "./reports/types";
import { defaultReportsState } from "./reports/default";
import { IStudentReportState } from "./StudentReport/type";
import { defaultStudentReportState } from "./StudentReport/deafult";
import {
  IReceiptReport,
  IReceiptReportState,
} from "./receiptReport/recieptypes";
import {
  defaultReceiptReport,
  defaultReceiptReportState,
} from "./receiptReport/default";
import {
  ICourseAndBatchReport,
  ICourseAndBatchReportState,
} from "./courseandbatchReport/type";
import { defaultCourseandBatchReportState } from "./courseandbatchReport/default";
import { ITotalRecordsState } from "./TotalRecords/types";
import { defaultTotalRecordsState } from "./TotalRecords/default";
import { IPaymentTypeState } from "./PaymentType/paymentType";
import { defaultPaymentTypeState } from "./PaymentType/default";
import { IOptionalFeeState } from "./optionalFee/optionaltype";
import {
  defaultOptionalFee,
  defaultOptionalFeeState,
} from "./optionalFee/default";

export interface IDropdownListType {
  key: string;
  text: string;
  value: string;
}

export interface IStoreState {
  customizerReducer: ICustomizerState;
  student: IStudentState;
  message: IMessagesState;
  acitivty: IAcitivtyState;
  security: ISecurityState;

  userprofile: IUsersState;
  common: ICommonState;
  templates: ITemplateState;

  opportunites: IOpportunityState;
  leads: ILeadsState;
  feeStructure: IFeeStructureState;
  masterOrganization: IOrganizationState;
  reports: IReportsState;
  studentReport: IStudentReportState;
  recieptReport: IReceiptReportState;
  courseandbatch: ICourseAndBatchReportState;
  TotalRecords: ITotalRecordsState;
  paymentType: IPaymentTypeState;
  optionalFee: IOptionalFeeState; // Add this line to include optionalFee in the store state
  //HR
}

export const initialStoreState: IStoreState = {
  //if you want to change the theme of framework, first go to themevariable.ts file, and set your theme there, then come in this file and simply put your theme in activveTheme
  customizerReducer: {
    activeDir: "ltr",
    activeNavbarBg: "#0b70fb", // This can be any color,
    activeSidebarBg: "#ffffff", // This can be any color
    activeMode: "light", // This can be light or dark
    activeTheme: "FEE_MANAGEMENT_THEME", // BLUE_THEME, GREEN_THEME, RED_THEME, BLACK_THEME, PURPLE_THEME, INDIGO_THEME
    SidebarWidth: 240,
    sidebarOpen: true,
  },

  student: defaultStudentState,
  message: initialMessagesState,
  templates: initialTemplateState,
  security: initialSecurityState,

  common: defaultCommonState,
  acitivty: initialAcitvityState,

  userprofile: initialUserProfileState,

  opportunites: defaultOpportunityState,
  leads: initialLeadState,
  feeStructure: defaultFeeStructureState,
  masterOrganization: defaultOrganizationState,
  reports: defaultReportsState,
  studentReport: defaultStudentReportState,
  recieptReport: defaultReceiptReportState,
  courseandbatch: defaultCourseandBatchReportState,
  TotalRecords: defaultTotalRecordsState,
  paymentType: defaultPaymentTypeState,
  optionalFee: defaultOptionalFeeState, // Initialize optionalFee state here
};
